import Vue from 'vue';
import { SpinnerPlugin, IconsPlugin, ModalPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import App from '@/App.vue';
import router from '@/router';
import store from '@/stores';
import alertService from '@/services/alertService';
import i18n from '@/i18n'
import '@/assets/styles/main.styl';

Vue.use(SpinnerPlugin);
Vue.use(IconsPlugin);
Vue.use(ModalPlugin);
Vue.config.productionTip = false;
i18n.locale = navigator.language;

alertService.init('Veeva Engage', i18n.t('OK'), i18n.t('CANCEL_MESSAGE'));

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
